import styled from 'styled-components';

export const InputGroupContainer = styled.div`
  padding: .3em;
  border-radius: .5em;
  border: 1px solid #ccc;

  &.has-error,
  &.is-required {
    border-color: red;
  }

  &:focus-within {
    border-color: blue;
  }
    
  .red-star {
    color: red;
    font-weight: bold;
  }
`